import { APICore } from "./apiCore";

const api = new APICore();

const listarGrauParentesco = (query?: string) => {
  return api.get(`/grauparentesco${query ? "?" + query : ""}`);
};

export { listarGrauParentesco };
